import React from 'react'

const HeaderAddon = ({
  render,
  sectionId,
}: {
  render: (sectionId: string) => React.ReactNode
  sectionId: string
}) => {
  return <>{render(sectionId)}</>
}

export const MemoizedSectionHeaderAddon = React.memo(HeaderAddon)
